import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #FF4D00;
    --secondary-color: #FF8A00;
    --dark-color: #1A1A1A;
    --light-color: #FFF5F2;
    --text-color: #2D2D2D;
    --white: #ffffff;
    --gradient: linear-gradient(135deg, #FF4D00, #FF8A00);
    --box-shadow: 0 10px 30px rgba(255, 77, 0, 0.1);
    --border-radius: 16px;
    --card-bg: rgba(255, 255, 255, 0.98);
    
    /* Typography Scale */
    --text-xs: 0.75rem;    /* 12px */
    --text-sm: 0.875rem;   /* 14px */
    --text-base: 1rem;     /* 16px */
    --text-lg: 1.125rem;   /* 18px */
    --text-xl: 1.25rem;    /* 20px */
    --text-2xl: 1.5rem;    /* 24px */
    --text-3xl: 1.875rem;  /* 30px */
    --text-4xl: 2.25rem;   /* 36px */
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
  }

  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
  }

  #root {
    height: 100%;
    width: 100%;
  }

  /* Landing page styles */
  .landing-page {
    min-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  /* Dashboard styles */
  .dashboard-container {
    height: 100vh;
    overflow: hidden;
  }

  /* Main content container styles */
  .main-content {
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    -webkit-overflow-scrolling: touch;
  }

  /* Table container styles */
  .table-container {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(100vh - 200px);
    -webkit-overflow-scrolling: touch;
  }

  /* Custom scrollbar styling */
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(255, 77, 0, 0.2);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 77, 0, 0.4);
  }

  body {
    line-height: 1.6;
    color: var(--text-color);
    background-color: var(--light-color);
    font-size: 16px;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    width: 100%;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Ensure modals don't cause page shift */
  .modal-open {
    overflow: hidden;
    padding-right: 0 !important;
  }
`;

export default GlobalStyles;
